export default function() {
  const widgetName = 'cardWidgetAnnouncement';
  const widgetOpts = cardWidgetAnnouncementOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).prepend(`
        <div class="cw-shape cw-shape-1">
          <div></div>
        </div>
        <div class="cw-shape cw-shape-2">
          <div></div>
        </div>
      `);

      const tierone = $('.section-tier-one');
      let cwheight = $(`#${widgetName} .card-widget-item`).outerHeight() - 20;

      if (window.innerWidth < 1024) {
        tierone.css('padding-top', `${cwheight}px`);
      } else {
        tierone.css('padding-top', '0px');
      }

      $(window).resize(function() {
        if (window.innerWidth < 1024) {
          let cwheight = $(`#${widgetName} .card-widget-item`).outerHeight() - 20;
          tierone.css('padding-top', `${cwheight}px`);
        } else {
          tierone.css('padding-top', '0px');
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE >>'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}